import { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { pageURLs } from "@/constants";
import { getUserType } from "../../../../helpers/common";
import { fetchUserStatistics } from "../../../../actions/userprofile";
import { USER_INFO_KEY, USER_TYPE_AGENT, USER_TYPE_MEMBER } from "../../../../constants/common";
import PremiumPlanModal from "../../../../components/PlanUpgrade/PremiumPlanModal";
import BasicPlanModal from "../../../../components/PlanUpgrade/BasicPlanModal";
import { getLocalStorage } from "@/helpers/v2/common";
import { useMLSAgentAtGitchaRedirect } from "@/hooks/useMLSAgentAtGitchaRedirect";
import { openModal } from "@/reducers/modals";
import { useAppConfig } from "@/appConfig";
import { isMlsRestrictedTenant } from "@/helpers/tenant";
import "../_match-cta-glow.scss";

const AddProperty = (props) => {
  const { userDetails, selectedClient } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userStatictics = useSelector(
    (state) => state?.userProfile?.userStatictics,
  );
  const userPrivileges = useSelector(
    (state) => state?.userProfile?.userPrivileges,
  );
  const [userCount, setUserCount] = useState({});
  const [allowedCount, setAllowedCount] = useState({});
  const [showPremiumPlanModal, setPremiumPlanModal] = useState(false);
  const PremiumPlanModalClose = () => setPremiumPlanModal(false);
  const PremiumPlanModalShow = () => setPremiumPlanModal(true);
  const [showBasicPlanModal, setBasicPlanModal] = useState(false);
  const BasicPlanModalClose = () => setBasicPlanModal(false);
  const BasicPlanModalShow = () => setBasicPlanModal(true);
  const [reload, setReload] = useState(0);
  const userType = getUserType();

  const { redirectToBLSEnv } = useMLSAgentAtGitchaRedirect();
  const { tenant } = useAppConfig() || {};
  const isBLS = isMlsRestrictedTenant(tenant);

  const isMember = userType === USER_TYPE_MEMBER;
  const copy = isMember
    ? {
        body: "Add your property to see real-time buyer demand and get market intelligence. Properties stay completely private.",
        cta: "Add Inventory",
      }
    : {
        body: isBLS
          ? "Add your client's property to see real-time buyer demand. Properties stay completely private to you."
          : "Add your client's property to see real-time buyer demand. Properties stay completely private until you choose to share them.",
        cta: isBLS ? "Add Prospect's Inventory" : "Add Inventory",
      };

  useEffect(() => {
    const payload = {
      UserPlanId: userDetails?.User_Plan_Id,
    };

    dispatch(fetchUserStatistics(payload));
  }, [userDetails]);

  useEffect(() => {
    if (userPrivileges !== null && userPrivileges.length > 0) {
      setAllowedCount(userPrivileges[0]);
    } else {
      setAllowedCount({});
    }
  }, [userPrivileges]);

  useEffect(() => {
    if (userStatictics !== null && userStatictics.length > 0) {
      //To fetch user statisctics
      setUserCount(userStatictics[0]);
    } else {
      setUserCount({});
    }
  }, [userStatictics]);

  const updateReloadParam = () => {
    setReload(reload + 1);
  };
  /**
   * To handle add property
   */

  const user = getLocalStorage(USER_INFO_KEY);

  const handleAddProperty = () => {
    redirectToBLSEnv({
      path: pageURLs.agentCreateInventory, onGitchaEnvFallback: () => {

        if (!user) {
          window.history.pushState({}, "", `${window.location.pathname}?auth=login`);
          dispatch(openModal({ name: "loginModal", data: { show: true } }))
          return;
        }

        if (userCount?.Inventory >= allowedCount?.Inventory) {
          if (userType === USER_TYPE_AGENT) {
            PremiumPlanModalShow();
          } else {
            BasicPlanModalShow();
          }
        } else {
          if (userType === USER_TYPE_AGENT) {
            navigate(pageURLs.agentCreateInventory, {
              state: {
                data: {
                  clientId: selectedClient?.value,
                  clientName: selectedClient?.label,
                  isAgentAsSeller: selectedClient?.AgentAsSeller,
                },
              },
            });
          } else {
            navigate(pageURLs.memberCreateInventory);
          }
        }
      }
    })


  };

  return (
    <>
      <div className="match-cta-glow">
        <div className="match-cta-glow__inner">
          <h3 className="match-cta-glow__heading">Gauge Real-Time Demand</h3>
          <p className="match-cta-glow__body">{copy.body}</p>
          <button
            className="btn btn-primary match-cta-glow__btn"
            onClick={() => handleAddProperty()}
          >
            {copy.cta}
          </button>
        </div>
      </div>
      <PremiumPlanModal
        userDetails={userDetails}
        updateReloadParam={updateReloadParam}
        show={showPremiumPlanModal}
        onHide={PremiumPlanModalClose}
        fromInventoryListing={true}
        showPlanModal={PremiumPlanModalShow}
      />
      <BasicPlanModal
        userDetails={userDetails}
        show={showBasicPlanModal}
        updateReloadParam={updateReloadParam}
        onHide={BasicPlanModalClose}
        fromInventoryListing={true}
        showPlanModal={BasicPlanModalShow}
      />
    </>
  );
};

export default AddProperty;
